import { render, staticRenderFns } from "./NormalSearchNav323.vue?vue&type=template&id=12e20dc0&scoped=true"
import script from "./NormalSearchNav323.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav323.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e20dc0",
  null
  
)

export default component.exports